/**
 * Get a single organization possible legal statuses
 * @param {object} state - the vuex state object
 * @return {array} - Possible statuses array
 */
export const getOrganizationPossibleStatuses = (state) => state.possibleStatuses;

/**
 * Get product types
 * @param {object} state - the vuex state object
 * @return {array} - Product types array
 */
export const getProductTypes = (state) => state.productTypes;

/**
 * Get product subtypes
 * @param {object} state - the vuex state object
 * @return {array} - Product subtypes array
 */
export const getProductSubtypes = (state) => state.productSubtypes;

/**
 * Get organization documents
 * @param {object} state - the vuex state object
 * @return {array} - Documents array
 */
 export const getDocuments = (state) => state.documents;

/**
 * Get identification types
 * @param {object} state - the vuex state object
 * @return {array} - Identification types array
 */
export const getIdentificationTypes = (state) => state.identificationTypes;

/**
 * Get equipments
 * @param {object} state - the vuex state object
 * @return {array} - Equipments array
 */
  export const getEquipments = (state) => state.equipments;

/**
 * Get languages
 * @param {object} state - the vuex state object
 * @return {array} - Languages array
 */
  export const getLanguages = (state) => state.languages;
  export const getStep = (state) => state.step;
  export const getMemberAddress = (state) => state.address;
  export const getMemberPhone = (state) => state.phone;
  export const getMemberSkills = (state) => state.skills;
  export const getMemberEquipment = (state) => state.memberEquipment;
  export const getMemberProfile = (state) => state.profile;
